// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/fraud.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ActivateWeightsRequest, ActivateWeightsResponse, GetActiveWeightsRequest, GetActiveWeightsResponse, GetFraudOverviewRequest, GetFraudOverviewResponse, LabelClickRequest, LabelClickResponse, ListProposedWeightsRequest, ListProposedWeightsResponse, SaveWeightsRequest, SaveWeightsResponse } from "./fraud_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.FraudService
 */
export const FraudService = {
  typeName: "tracker.v1.FraudService",
  methods: {
    /**
     * LabelClick records a human verdict on a click (supervises the feedback loop).
     *
     * @generated from rpc tracker.v1.FraudService.LabelClick
     */
    labelClick: {
      name: "LabelClick",
      I: LabelClickRequest,
      O: LabelClickResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetFraudOverview returns traffic-quality rollups for the dashboard.
     *
     * @generated from rpc tracker.v1.FraudService.GetFraudOverview
     */
    getFraudOverview: {
      name: "GetFraudOverview",
      I: GetFraudOverviewRequest,
      O: GetFraudOverviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListProposedWeights returns pending weight-tuning proposals.
     *
     * @generated from rpc tracker.v1.FraudService.ListProposedWeights
     */
    listProposedWeights: {
      name: "ListProposedWeights",
      I: ListProposedWeightsRequest,
      O: ListProposedWeightsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ActivateWeights promotes a proposal to the active weight set.
     *
     * @generated from rpc tracker.v1.FraudService.ActivateWeights
     */
    activateWeights: {
      name: "ActivateWeights",
      I: ActivateWeightsRequest,
      O: ActivateWeightsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetActiveWeights returns the effective weight set for a scope plus the
     * shipped defaults, for the manual tuning editor.
     *
     * @generated from rpc tracker.v1.FraudService.GetActiveWeights
     */
    getActiveWeights: {
      name: "GetActiveWeights",
      I: GetActiveWeightsRequest,
      O: GetActiveWeightsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SaveWeights directly activates an admin-edited weight set for a scope.
     *
     * @generated from rpc tracker.v1.FraudService.SaveWeights
     */
    saveWeights: {
      name: "SaveWeights",
      I: SaveWeightsRequest,
      O: SaveWeightsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

